import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocFile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.5 1.5h7l2.5 2.5v10a1 1 0 0 1-1 1h-8.5a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1z",
			stroke: "currentColor",
			strokeLinejoin: "round",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 1.5v3h3",
			stroke: "currentColor",
			strokeLinejoin: "round",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("line", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: 1.2,
			x1: 5,
			x2: 11,
			y1: 6.5,
			y2: 6.5
		}),
		/* @__PURE__ */ _jsx("line", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: 1.2,
			x1: 5,
			x2: 11,
			y1: 9,
			y2: 9
		}),
		/* @__PURE__ */ _jsx("line", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: 1.2,
			x1: 5,
			x2: 9,
			y1: 11.5,
			y2: 11.5
		})
	]
});
export default SvgDocFile;
